export default function SampleReport() {
  return (
    <section
      id="report"
      className="py-20"
      style={{ background: '#0D2B55', fontFamily: "'Noto Sans JP', sans-serif" }}
    >
      <div className="max-w-[1080px] mx-auto px-6">
        {/* セクションヘッダー */}
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-white mb-4" style={{ letterSpacing: '-0.01em' }}>
            診断レポートのサンプル
          </h2>
          <p className="text-sm" style={{ color: 'rgba(255,255,255,0.65)' }}>
            診断後、貴社の現状スコアと改善提案をまとめたレポートを納品いたします
          </p>
        </div>

        {/* レポート画像カード */}
        <div
          className="relative mx-auto max-w-4xl"
          style={{ filter: 'drop-shadow(0 8px 40px rgba(0,0,0,0.45))' }}
        >
          {/* 上部タブ風デコ */}
          <div
            className="flex items-center gap-2 px-5 py-3 rounded-t-xl"
            style={{ background: '#1A2E4A', borderBottom: '1px solid rgba(255,255,255,0.08)' }}
          >
            <span className="w-3 h-3 rounded-full bg-red-400 opacity-80"></span>
            <span className="w-3 h-3 rounded-full bg-yellow-400 opacity-80"></span>
            <span className="w-3 h-3 rounded-full bg-green-400 opacity-80"></span>
            <span
              className="ml-3 text-xs"
              style={{ color: 'rgba(255,255,255,0.4)', fontFamily: 'monospace' }}
            >
              KT_Partners_診断レポート_サンプル.pdf
            </span>
          </div>

          {/* 画像本体 */}
          <div
            className="rounded-b-xl overflow-hidden"
            style={{ background: '#fff' }}
          >
            <img
              src="https://storage.readdy-site.link/project_files/538e17c4-7ffa-4402-ad52-2c2b62ba2b7b/5c232bbf-4658-465b-ade3-5089744c27fd_report.png?v=0e83e986a0be04031c5dfbcd562a0fdc"
              alt="人事制度診断レポート サンプル"
              className="w-full h-auto object-top"
            />
          </div>
        </div>

        {/* 下部注釈 */}
        <div className="mt-8 text-center">
          <p
            className="inline-flex items-center gap-2 text-sm px-5 py-3 rounded-lg"
            style={{ background: 'rgba(255,255,255,0.08)', color: 'rgba(255,255,255,0.7)' }}
          >
            <span>📄</span>
            <span>無料版レポートのサンプルです。有料版ではさらに詳細な内容をレポートします。</span>
          </p>
        </div>

        {/* CTA */}
        <div className="mt-10 text-center">
          <a
            href="https://products-eight-sand.vercel.app/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 font-bold text-base px-8 py-4 rounded-lg transition-all cursor-pointer whitespace-nowrap"
            style={{
              background: 'linear-gradient(135deg, #2D8EFF, #1A5CB0)',
              color: '#fff',
              boxShadow: '0 4px 20px rgba(45,142,255,0.4)',
            }}
          >
            無料診断でレポートを受け取る
          </a>
        </div>
      </div>
    </section>
  );
}
